<div class="modal-backdrop">
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">{{changeTeamLabels.title}}</h2>
      <button class="close-btn" (click)="onClose()">×</button>
    </div>
    <form [formGroup]="changeTeamForm" (ngSubmit)="onSubmit()">
      <div class="modal-body">
        <div class="form-column">
          <div class="form-field">
            <emerald-datepicker
              [label]="changeTeamLabels.startDate"
              [isOutlined]="true"
              [forceRefresh]="true"
              formControlName="startDate"
            ></emerald-datepicker>
          </div>
          <div class="form-field">
            <emerald-dropdown
              [label]="changeTeamLabels.newProject"
              [outlined]="true"
              [showFilter]="true"
              [isValid]="true"
              [options]="newProductOptions"
              [preSelectedLabel]="'label'"
              [preSelectedValue]="'value'"
              formControlName="newProjectId"
            ></emerald-dropdown>
          </div>
          <div class="form-field">
            <emerald-datepicker
              [label]="changeTeamLabels.endDate"
              [isOutlined]="true"
              [forceRefresh]="true"
              formControlName="endDate"
            ></emerald-datepicker>
          </div>
          <div class="form-field">
            <emerald-dropdown
              [label]="changeTeamLabels.oldProject"
              [outlined]="true"
              [showFilter]="true"
              [isValid]="true"
              [options]="currentProductOptions"
              [preSelectedLabel]="'label'"
              [preSelectedValue]="'value'"
              formControlName="oldProjectId"
              [multiSelect]="false"
            ></emerald-dropdown>
          </div>
          <div class="form-field">
            <label for="comments-input">{{changeTeamLabels.comments}}</label>
            <textarea
              id="comment"
              class="emerald-textarea"
              rows="3"
              placeholder="{{changeTeamLabels.comments}}"
              formControlName="comments"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="modal-actions">
        <emerald-button
          [label]="changeTeamLabels.cancel"
          [type]="'Secondary'"
          (onClick)="onClose()"
        ></emerald-button>
        <emerald-button
          [label]="changeTeamLabels.submit"
          [type]="'Primary'"
          [disabled]="isSubmitDisabled"
        ></emerald-button>
      </div>
    </form>
  </div>
</div>
